
import { defineComponent, computed } from 'vue'
import ConfirmInput from '@/components/organisms/dms/common/ConfirmInput.vue'

export default defineComponent({
  name: 'OthersConfirm',
  components: {
    ConfirmInput,
  },
  props: {
    modelValue: {
      type: String,
    },
  },
  setup (props, { emit }) {
    const state = computed({
      get: () => props.modelValue,
      set: (state) =>
        emit('update:modelValue', state),
    })
    return {
      props,
      state,
    }
  },
})
